module.exports = __webpack_public_path__ + "static/media/BudgetTracker.95d9a6c9.png";